<template>
  <section class="container mx-auto px-4 md:px-8 py-10 md:py-14">
    <h1 class="text-3xl md:text-4xl font-extrabold mb-6">
      Політика конфіденційності
    </h1>

    <div class="prose prose-neutral max-w-none">
      <p>
        Ми поважаємо вашу приватність. У цій політиці пояснюємо, які дані ми
        збираємо, з якою метою та як їх захищаємо.
      </p>

      <h2>1. Хто ми</h2>
      <p>Інтернет-магазин mulberry’ss (далі — «Ми», «Сервіс»).</p>

      <h2>2. Які дані ми збираємо</h2>
      <ul>
        <li><strong>Облікові</strong>: ім’я, телефон, за потреби email.</li>
        <li>
          <strong>Доставка</strong>: місто, відділення/поштомат (Нова Пошта).
        </li>
        <li>
          <strong>Технічні</strong>: cookie-файли, IP, дані пристрою (для
          безпеки та статистики).
        </li>
      </ul>

      <h2>3. Навіщо ми це робимо</h2>
      <ul>
        <li>Оформлення та виконання замовлень.</li>
        <li>Підтримка користувачів та комунікація.</li>
        <li>Покращення роботи сайту (агрегована статистика).</li>
      </ul>

      <h2>4. З ким ділимося</h2>
      <p>
        З перевізниками (Нова Пошта) — лише необхідними даними для доставки.
        Аналітика/маркетинг підключаються <em>лише за згодою cookie</em>.
      </p>

      <h2>5. Термін зберігання</h2>
      <p>
        Облікові та замовлення — відповідно до вимог обліку та гарантій;
        технічні дані — згідно налаштувань cookie.
      </p>

      <h2>6. Ваші права</h2>
      <ul>
        <li>Доступ, виправлення, видалення, обмеження обробки.</li>
        <li>
          Відкликання згоди на cookie у будь-який момент на сторінці
          <NuxtLink to="/cookies">Налаштування cookie</NuxtLink>.
        </li>
      </ul>

      <h2>7. Безпека</h2>
      <p>
        Використовуємо захищені з’єднання (HTTPS), контроль доступу та
        мінімізацію даних.
      </p>

      <h2>8. Контакти</h2>
      <p>
        Звертайтесь через сторінку <NuxtLink to="/contacts">Контакти</NuxtLink>.
      </p>

      <p class="text-sm text-gray-500 mt-8">Оновлено: {{ today }}</p>
    </div>
  </section>
</template>

<script setup>
const today = new Date().toLocaleDateString("uk-UA");
useHead({
  title: "Політика конфіденційності — mulberry’ss",
  meta: [
    {
      name: "description",
      content:
        "Як ми обробляємо персональні дані: облік замовлень, доставка, підтримка користувачів, налаштування cookie.",
    },
  ],
});
</script>
